import React from 'react';
import PropTypes from 'prop-types';

const UserPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M7.998 12a8 8 0 0 0 8 8 7.999 7.999 0 0 0 7.999-8 8 8 0 1 0-15.999 0zm8 10.5a10.45 10.45 0 0 1-6.109-1.958c-3.022 1.201-5.19 3.323-5.75 6.044-.093.455-.061.413-.061.413A.91.91 0 0 0 4.998 28h21.999a.911.911 0 0 0 .923-.997s.034.094-.048-.336c-.533-2.76-2.715-4.912-5.766-6.125a10.451 10.451 0 0 1-6.108 1.958z"
    />
  );
};

UserPath.propTypes = {
  fill: PropTypes.string,
};

export default UserPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/user/user.jsx